import '@ungap/custom-elements' // fix safari

import './scrolled'
import './form'
import './popup'
import './slider'
import './webcomponent/scroll-animate'

console.log('ok!')
